export default [
  {
    path: "/settings/organization-hierachy",
    name: "OrganizationHierarchy",
    component: () => import("@/views/3pl/Settings/OrganizationHierachy/index"),
  },
  {
    path: "/settings/organization-hierachy/create-function",
    name: "CreateFunction",
    component: () =>
      import("@/views/3pl/Settings/OrganizationHierachy/CreateFunction"),
  },
  // {
  //   path: "/settings/organization-hierachy/create-joblevel",
  //   name: "CreateJobLevel",
  //   component: () =>
  //     import("@/views/3pl/Settings/OrganizationHierachy/CreateJobLevel"),
  // },
  {
    path: "/settings/organization-hierachy/create-designation",
    name: "CreateDesignation",
    component: () =>
      import("@/views/3pl/Settings/OrganizationHierachy/CreateDesignation"),
  },
  {
    path: "/settings/organization-hierachy/create-user",
    name: "CreatePerson",
    component: () =>
      import("@/views/3pl/Settings/OrganizationHierachy/CreatePerson"),
  },
  {
    path: "/settings/organization-hierachy/edit-function",
    name: "EditFunction",
    component: () =>
      import("@/views/3pl/Settings/OrganizationHierachy/EditFunction"),
  },
  // {
  //   path: "/settings/organization-hierachy/edit-job-level",
  //   name: "EditJobLevel",
  //   component: () =>
  //     import("@/views/3pl/Settings/OrganizationHierachy/EditJobLevel"),
  // },
  {
    path: "/settings/organization-hierachy/edit-designation",
    name: "EditDesignation",
    component: () =>
      import("@/views/3pl/Settings/OrganizationHierachy/EditDesignation"),
  },
  {
    path: "/settings/organization-hierachy/edit-person",
    name: "EditPerson",
    component: () =>
      import("@/views/3pl/Settings/OrganizationHierachy/EditPerson"),
  },
  {
    path: "/settings/organization-hierarchy/org-structure",
    name: "OrganizationStructure",
    component: () =>
      import("@/views/3pl/Settings/OrganizationHierachy/OrganizationStructure"),
  },
];
